<template>
    <div id="structure-create" class="page-layout__inner w-100">
        <div class="row w-100">
            <div class="col-md-7">
                <div class="section">
                    <EditCreateComponent/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import EditCreateComponent from "./components/EditCreateComponent";

    export default {
        name: "Create",
        components: {EditCreateComponent},
    }
</script>

<style scoped>

</style>